<template>
  <!-- Inherits the surrounding text colour so it stays legible on any surface. -->
  <Font-awesome-icon :icon="['fas', 'spinner']" :size="size" />
</template>

<script>
export default {
  name: "LoadingSymbol",
  props: {
    size: { default: "lg" },
  },
};
</script>

<style scoped>
/* Define an animation behavior */
@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

/* This is the class name given by the Font Awesome component when icon contains 'spinner' */
.fa-spinner {
  /* Apply 'spinner' keyframes looping once every second (1s)  */
  animation: spinner 1.25s linear infinite;
}
</style>
